import { httpClient } from '@/services/http/httpClient';
import type {
  OnboardingStatus,
  OnboardingResponse,
  SaveOnboardingRequest,
  StartAutomationResult,
  AutomationStatusResponse,
} from '@/types';

export const onboardingApi = {
  /** GET /api/onboarding — fetch current onboarding status */
  async getOnboardingStatus() {
    return httpClient.get<OnboardingStatus>('/onboarding');
  },

  /** PUT /api/onboarding — save onboarding form data */
  async saveOnboarding(data: SaveOnboardingRequest) {
    return httpClient.put<OnboardingResponse>('/onboarding', data);
  },

  /** POST /api/onboarding/automation/start — trigger the automation pipeline */
  async startAutomation() {
    return httpClient.post<StartAutomationResult>('/onboarding/automation/start');
  },

  /** GET /api/onboarding/automation/status — poll automation pipeline progress */
  async getAutomationStatus() {
    return httpClient.get<AutomationStatusResponse>('/onboarding/automation/status');
  },
};
